<mat-form-field [appearance]="appearance" class="form-control-container" [floatLabel]="label ? floatLabel : 'never'">
  <mat-label *ngIf="label">{{ getDisplayLabel() }}</mat-label>
  <mat-icon *ngIf="prefixIcon" matPrefix width="24px" height="24px">{{ prefixIcon }}</mat-icon>
  <mat-icon *ngIf="suffixIcon && !refreshAction" matSuffix width="24px" height="24px">{{ suffixIcon }}</mat-icon>
  <button
    mat-icon-button
    class="mat-icon-button"
    *ngIf="refreshAction && !clearable"
    color="primary"
    matSuffix
    (click)="onRefreshClickedAction($event)"
  >
    <mat-icon>sync</mat-icon>
  </button>
  <button
    mat-icon-button
    class="mat-icon-button"
    *ngIf="clearable"
    color="primary"
    matSuffix
    (click)="control.patchValue('')"
  >
    <mat-icon>clear</mat-icon>
  </button>
  <ng-container *ngIf="type !== 'textarea' && type !== 'colorPicker'">
    <!-- Number input with min, max, or step -->
    <input
      *ngIf="type === 'number' && (min || max || step)"
      class="input"
      matInput
      [formControl]="control"
      [type]="type"
      [placeholder]="placeholder"
      [min]="min"
      [max]="max"
      [step]="step"
      (input)="onInput($event)"
    />
    <!-- Input with mask and max -->
    <input
      *ngIf="mask && max && type !== 'number'"
      [waiMask]="mask"
      matInput
      appPercentageDirective
      [formControl]="control"
      [type]="type"
      [placeholder]="placeholder"
      (keypress)="onKeyPressed($event)"
      [max]="max"
      (input)="onInput($event)"
    />
    <!-- Input with mask but no min/max -->
    <input
      *ngIf="mask && !min && !max && type !== 'number'"
      [waiMask]="mask"
      matInput
      [formControl]="control"
      [type]="type"
      [placeholder]="placeholder"
      (keypress)="onKeyPressed($event)"
      (input)="onInput($event)"
    />
    <!-- Default input (no mask, no min/max/step for numbers) -->
    <input
      *ngIf="!mask && (!min && !max && !step || type !== 'number')"
      class="input"
      matInput
      [formControl]="control"
      [matAutocomplete]="autocomplete"
      [matAutocompleteDisabled]="!autocomplete"
      [type]="type"
      [placeholder]="placeholder"
      (keypress)="onKeyPressed($event)"
      (input)="onInput($event)"
    />
  </ng-container>
  <ng-container *ngIf="type === 'colorPicker'">
    <input
      matInput
      [formControl]="control"
      class="input"
      type="text"
      [placeholder]="placeholder"
      (input)="onColorInputChange($event)"
    />
    <!-- Hidden native color picker -->
    <input
      #colorPickerInput
      type="color"
      class="color-picker-native"
      [value]="control.value || '#000000'"
      (input)="onColorPickerChange($event)"
    />
  </ng-container>
  <!-- Color circle button - outside ng-container so matSuffix works correctly -->
  <button
    *ngIf="type === 'colorPicker'"
    type="button"
    matSuffix
    class="color-picker-button"
    [style.background-color]="control.value || '#000000'"
    (click)="openColorPicker()"
    [attr.aria-label]="'Select color'"
  ></button>

  <textarea
    *ngIf="type === 'textarea'"
    rows="4"
    cdkAutosizeMaxRows="10"
    cdkAutosizeMinRows="1"
    cdkTextareaAutosize
    matInput
    [formControl]="control"
  ></textarea>

  <span *ngIf="suffix" matSuffix>{{ suffix }}</span>
  <mat-hint>{{ hint | translate }}</mat-hint>
  <mat-error>
    <wai-form-error [formField]="control"></wai-form-error>
  </mat-error>
  <div matSuffix class="tooltip-container" *ngIf="tooltip">
    <mat-icon class="icon" aria-label="Tooltip" matTooltip="{{ tooltip }}" matTooltipClass="custom-tooltip"
      >error_outline</mat-icon
    >
    <!-- <div class="tooltip">{{ tooltip }}</div> -->
  </div>
</mat-form-field>
